import { IgenomicsAction } from "@ispm/core/interfaces/genomics-action.interface";
import { ILogiDashboardsDetails } from "../../interfaces/analytics-configuration.interface";
import { SetLogiDashboardDetails } from "../actions/analytics.actions";


export interface AnalyticsState {
  logiDashboardsDetails?: ILogiDashboardsDetails;
}

export function analyticsReducer(state: AnalyticsState = { }, action: IgenomicsAction): AnalyticsState {
  switch (action.type) {
    case SetLogiDashboardDetails:
      return { ...state, logiDashboardsDetails: action.payload};
    default:
      return state;
  }
}
